// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import type { History } from 'history';
import React from 'react';
import { createPortal } from 'react-dom';
import { Route, Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

interface ContextProps {
	children:
		| string
		| React.FunctionComponent<any>
		| React.ComponentClass<any, any>;
	history: History;
	path: string;
	scope: string;
}

const Context = ({ children, history, path, scope }: ContextProps) => (
	<>
		{scope === 'content' && createPortal(<ToastContainer />, document.body)}
		<Router history={history}>
			<Route path={path}>
				{React.isValidElement(children)
					? children
					: React.createElement(children)}
			</Route>
		</Router>
	</>
);

export default Context;
